export const ACTIVE_INTERNAL_CHAT_POSITION = "ACTIVE_INTERNAL_CHAT_POSITION";
export const FULL_DIALOG_INTERNAL = "FULL_DIALOG_INTERNAL";
export const ROLE_DESCRIPTION = "ROLE_DESCRIPTION";
export const TEXT_MESSAGE_INTERNAL = "TEXT_MESSAGE_INTERNAL";
export const INTERNAL_MUTED = "INTERNAL_MUTED";